<template lang="html">
<v-container grid-list-xl>

<v-layout align-center justify-center> <span class="display-3 text-align-center"> Blitz Canvas </span> </v-layout>

    <v-layout row wrap align-center justify-center class="mt-1">
      <v-flex xs12 sm6 md7 lg9>
        <v-hover>
        <v-card class="text-xs-center ma-3" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
          <v-card-text>
            <div class="headline mb-3">Blitz Canvas</div>
            <v-layout align-center justify-center>
              <div
                class="welcome-text subheading"
              >
              <p> Welcome to a business model development using the Blitz Canvas.
              <br/><br/>In the <b>NEXT TEN STEPS</b>, we will be developing a business model using the Blitz Canvas methodology. 
              The product offered to the customer is a To-Do list application and the business model will be built around 
              this application concept. 
              <br/><br/> Please choose the <b>"Let's get started"</b> button in card 1 to get started with the process.
              </p>

              
              </div>
            </v-layout>
          </v-card-text>
 
        </v-card>
        </v-hover>
      </v-flex>
    </v-layout>


<!--    <v-layout row wrap align-center justify-center class="mt-1">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
        <v-card class="text-xs-center ma-3" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
          <v-card-text>
            <div class="headline mb-3">Blitz Canvas</div>
            <v-layout align-center justify-center>
              <div
                class="welcome-text subheading"
              >
              <p> Welcome to the section on business model development.</p>

              
              </div>
            </v-layout>
          </v-card-text>

          <v-card-actions class="center">
            <v-layout column align-center justify-center>
              <v-btn dark color="primary" class="mb-3" router to="/bcfoundationelements01">Let's get started!</v-btn>
              <v-btn class="mb-3" router to="/Home">Head back all options</v-btn>
              
            </v-layout>
          </v-card-actions>
        </v-card>
        </v-hover>
      </v-flex>
    </v-layout>   -->



<v-layout>
    


    <v-flex xs12 md4>
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        layers
      </v-icon>
       
      <span class="title font-weight-normal">Step 1 - Build the Foundation</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <!-- <span>Urban dwellers who are employed and aged betwen 18 to 34 years.
       Solution is aimed at the consumer market segment. </span> -->
       Defining the organization's mission, vision and other foudational elements.
       <!-- Pages included in Step 1:
       bcfoundationelements01 -> addfoundationdetails
        -->
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        > 
          <!-- <v-btn to="/bcfoundationelements01" target="_self" color="primary" class="mx-2 mt-3" disabled>Let's Get started</v-btn>  -->
          <v-icon
        large
        left
        class="teal"
      >
        done
      </v-icon>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>


    <v-flex xs12 md4 >
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
      face
        <!-- person_pin -->
      </v-icon>
      <span class="title font-weight-normal">Step 2 - Studying the user</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
          Studying the user, who they are and understanding their pain points.
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
       <!-- <v-btn to="/bcfoundationelements01" target="_self" color="primary" class="mx-2 mt-3" disabled>Let's Get started</v-btn>  -->
          <v-icon
        large
        left
        class="teal"
      >
        done
      </v-icon>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>

 <v-flex xs12 md4>
      <v-hover>
    <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        touch_app
      </v-icon>
      <span class="title font-weight-normal">Step 3 - Defining the solution</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <!-- "There are too many tasks for me to handle. I find it hard to prioritise them and be productive while at it." -->
      Defining product goals, the features of the product and Creating a solution outline.
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
       <!-- <v-btn to="/bcfoundationelements01" target="_self" color="primary" class="mx-2 mt-3" disabled>Let's Get started</v-btn>  -->
          <v-icon
        large
        left
        class="teal"
      >
        done
      </v-icon>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>


  </v-layout>

<!-- //New Row -->

  


<v-layout>
    


    <v-flex xs12 md4>
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        important_devices
      </v-icon>
      <span class="title font-weight-normal">Step 4 - Unique selling proposition</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <!-- <span>Urban dwellers who are employed and aged betwen 18 to 34 years.
       Solution is aimed at the consumer market segment. </span> -->
       Highlighting what makes the solution unique and the customer touchpoints in focus.
       <!-- Pages included in Step 1:
       bcfoundationelements01 -> addfoundationdetails
        -->
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
       <!-- <v-btn to="/bcfoundationelements01" target="_self" color="primary" class="mx-2 mt-3" disabled>Let's Get started</v-btn>  -->
          <v-icon
        large
        left
        class="teal"
      >
        done
      </v-icon>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>


    <v-flex xs12 md4 >
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        feedback
      </v-icon>
      <span class="title font-weight-normal">Step 5 - The User's feedback</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
          Capturing the user's initial thoughts after they have tried out the solution.
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/dumaddquotes" target="_self" color="primary" class="mx-2 mt-3">Begin Step 5</v-btn> 
          <!--<v-btn to="/bifdashboard" color="primary">Begin Step 2</v-btn> -->
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>

 <v-flex xs12 md4>
      <v-hover>
    <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        group
      </v-icon>
      <span class="title font-weight-normal">Step 6 - Studying the competition</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <!-- "There are too many tasks for me to handle. I find it hard to prioritise them and be productive while at it." -->
      Studying the current market players and the solutions/features they offer.
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/dumcurrentmarketplayers" target="_self" color="primary" class="mx-2 mt-3">Begin Step 6</v-btn> 
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>


  </v-layout>

  <!-- //New Row -->

  


<v-layout>
    


    <v-flex xs12 md4>
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        pie_chart
      </v-icon>
      <span class="title font-weight-normal">Step 7 - Business model elements</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <!-- <span>Urban dwellers who are employed and aged betwen 18 to 34 years.
       Solution is aimed at the consumer market segment. </span> -->
       Define the business model elements, the IP and the services used.
       <!-- Pages included in Step 1:
       bcfoundationelements01 -> addfoundationdetails
        -->
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/addbmcelements" target="_self" color="primary" class="mx-2 mt-3">Begin Step 7</v-btn> 
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>


    <v-flex xs12 md4 >
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        sync_alt
      </v-icon>
      <span class="title font-weight-normal">Step 8 - Synergies</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
          Spot potential synergies between different parts of the business model.
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/bcpotentialsynergies" target="_self" color="primary" class="mx-2 mt-3">Begin Step 8</v-btn> 
          <!--<v-btn to="/bifdashboard" color="primary">Begin Step 2</v-btn> -->
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>

 <v-flex xs12 md4>
      <v-hover>
    <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        trending_up
      </v-icon>
      <span class="title font-weight-normal">Step 9 - Managing Growth</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <!-- "There are too many tasks for me to handle. I find it hard to prioritise them and be productive while at it." -->
      Outlining how the business intends to scale with growth and plan parallel products.
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/bchandlingscale" target="_self" color="primary" class="mx-2 mt-3">Begin Step 9</v-btn> 
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>


  </v-layout>

<!-- //New Row -->


  <v-layout align-center justify-center> 

 <v-flex xs12 md4>
      <v-hover>
    <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        track_changes
      </v-icon>
      <span class="title font-weight-normal">Step 10 - Metrics</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <!-- "There are too many tasks for me to handle. I find it hard to prioritise them and be productive while at it." -->
    List out the metrics which will be used to keep track of the business.
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/bcaddnorthstarmetrics" target="_self" color="primary" class="mx-2 mt-3">Begin Step 10</v-btn> 
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>


  </v-layout>

<!-- //New Row -->


  

  </v-container>
</template>



<script>
import db from '../fb'
//import Popup from '../components/Popup'
import gvars from '../globalvariables'

export default {
  name: "problemstudy",
  components: {
  //  Popup
  },
  data() {
    return { 
      linktolfwireframe: 'https://www.duckduckgo.com',
      doWe: false,
      projecttitle:'My Venture v22',
      projecttitleEnabled: false,
      projecttitleLabelText: 'Provide a title for your project',
      customerproblemdescription:'Description Blah Blah Blah Blah', 
      customerproblemdescriptionEnabled: false,
      customerproblemdescriptionLabelText: 'Describe the problem that the customer is facing',
      whythisproblem: 'Why Blah Blah Blah Blah',
      whythisproblemEnabled: false,
      whythisproblemLabelText: 'Why is the problem important to the customer?',
      targetagerange: 'between 18 and 60 years',
      targetagerangeEnabled: false,
      targetagerangeLabelText: 'What is the age range of the target audience?',
      problemdomain: 'Not Sure',      
      problemdomainEnabled: false,
      problemdomainLabelText: 'Which domain does this Problem fall in?',
      additionaldetailforproblem: 'Additional detail Blah Blah Blah Blah',
      additionaldetailforproblemEnabled: false,
      additionaldetailforproblemLabelText: 'Is there any other detail you would like to add?',
      dropdownList: [
        {component: 'projecttitle', isEnabled: false, titleText: 'Provide a title for your project'},
        {component: 'customerproblemdescription', isEnabled: false, titleText: 'Describe the problem that the customer is facing'},
        {component: 'whythisproblem', isEnabled: false, titleText: 'Why is the problem important to the customer?'},
        {component: 'targetagerange', isEnabled: false, titleText: 'What is the age range of the target audience?'},
        {component: 'problemdomain', isEnabled: false, titleText: 'Which domain does this Problem fall in?'},
        {component: 'additionaldetailforproblem', isEnabled: false, titleText: 'Is there any other detail you would like to add?'}
      ],
      customerproblemdetails: [
        { title: 'Add Project Title', storagecode: 'projecttitle', labeltext: 'Provide a title for your project', type: 'title', textValue: 'My Venture v2', prependicon: 'edit', componentid: true, tooltip: true },
        { title: 'Add Details of the customer problem', storagecode: 'customerproblemdescription', labeltext: 'Describe the problem that the customer is facing', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'edit', componentid: true, tooltip: true },
        { title: 'Add Importance of the problem to the customer', storagecode: 'whythisproblem', labeltext: 'Why is the problem important to the customer?', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'folder', componentid: false, tooltip: false },
        { title: 'Add Age range', storagecode: 'targetagerange', labeltext: 'What is the age range of the target audience?', type: 'agerange', prependicon: 'edit', componentid: false, tooltip: true },
        { title: 'Add the problem domain', storagecode: 'problemdomain', labeltext: 'Which domain does this Problem fall in?', type: 'select', textValue: 'Not Sure', prependicon: 'edit', componentid: false, tooltip: true },
        { title: 'Add additional misc. details', storagecode: 'additionaldetailforproblem', labeltext: 'Is there any other detail you would like to add?', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'edit', componentid: false, tooltip: true }
      ],
      solutionconcepts: [],
      quotes: [],
      quoteToBeDisplayed: [],
      solutionConceptDetailToBeDisplayed: [],
      parallelSolutionConceptsToBeDisplayed: [],
      businessfoundationdetails: [],
      aasofferings: [],
      ipproperties: [],
      potentialsynergies: [],
      competingproducts: [],
      slider: 45,
        volume: 10,
        age: [18, 60],
      items: ['Enterprise', 'Consumer', 'Both Enterprise and Consumer', 'Not Sure'],
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      snackbar: false
    }
  },
  methods: {
    submit(){
      //console.log(this.dropdownList[1].isEnabled)
      
//  if(this.$refs.form.validate()) {
//         console.log("Attempt to submit")
//         const project = {

//           projecttitle: this.projecttitle,
//           customerproblemdescription: this.customerproblemdescription,
//           whythisproblem: this.whythisproblem,
//           targetagerange: this.targetagerange,
//           problemdomain: this.problemdomain,
//           additionaldetailforproblem: this.additionaldetailforproblem
//         }

//       //   db.collection('projects').add(project).then(() => {
//       //     console.log("added to db!")
//       //   })
//       // }

//         db.collection('projects').add(project).then(function(docRef) {
//                 console.log("Document written with ID: ", docRef.id);
//             })
//             .catch(function(error) {
//                 console.error("Error adding document: ", error);
//             });
//         }

      this.$router.push('ranksolutions')

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
    
  },
  computed: {
    remainingDetailsToBeAdded(){
      return this.dropdownList.filter(dropdownListElement => {
        return dropdownListElement.isEnabled == false
      })
    }
  },
  created(){
    
// Getting the details of the solution concept - overall
db.collection('projects').doc(this.getProjectID()).get().then(res => {

      // console.log("snapshot looks like this:");
      // console.log(red.docs);

      if (res) {
       this.solutionConceptDetailToBeDisplayed = res.data() 
        //console.log(this.solutionConceptDetailToBeDisplayed.projecttitle)
      } else {
        //console.log('No document exists')
      }


    })




 

 // Getting the first customer quote from the list of quotes provided by the customer when using the application
 db.collection("projects").doc(this.getProjectID()).collection('quotesregardingfirstprefsolutionconcept')
.limit(1)
.get()
.then(querySnapshot => {
    if (!querySnapshot.empty) {
        //We know there is one doc in the querySnapshot
        const queryDocumentSnapshot = querySnapshot.docs[0]; 
        //console.log(queryDocumentSnapshot.ref.id)

        let ref = db.collection("projects").doc(this.getProjectID()).collection('quotesregardingfirstprefsolutionconcept').doc(queryDocumentSnapshot.ref.id)
          ref.get()
          .then(snapshot => {  //DocSnapshot
                if (snapshot.exists) {
                    this.quoteToBeDisplayed = snapshot.data()
                    //console.log(this.quoteToBeDisplayed.firstprefquotetext)
                } else {
                    // snapshot.data() will be undefined in this case
                    //console.log("No such document!");
                }  
          })


    } else {
        //console.log("No document corresponding to the query!");
        return null;
    }
});
// End of section retrieving quotes

 // Getting the first parallel solution concept from the list of such concepts  
 db.collection("projects").doc(this.getProjectID()).collection('parallelsolutionconcepts')
.limit(1)
.get()
.then(querySnapshot => {
    if (!querySnapshot.empty) {
        //We know there is one doc in the querySnapshot
        const queryDocumentSnapshot = querySnapshot.docs[0]; 
        //console.log(queryDocumentSnapshot.ref.id)

        let ref = db.collection("projects").doc(this.getProjectID()).collection('parallelsolutionconcepts').doc(queryDocumentSnapshot.ref.id)
          ref.get()
          .then(snapshot => {  //DocSnapshot
                if (snapshot.exists) {
                    this.parallelSolutionConceptsToBeDisplayed = snapshot.data()
                    //console.log(this.parallelSolutionConceptsToBeDisplayed.solutionname)
                } else {
                    // snapshot.data() will be undefined in this case
                    //console.log("No such document!");
                }  
          })


    } else {
        //console.log("No document corresponding to the query!");
        return null;
    }
});
// End of section 


// Getting the first business foundational detail concept from the list of such details  
 db.collection("projects").doc(this.getProjectID()).collection('businessfoundationdetails')
.limit(1)
.get()
.then(querySnapshot => {
    if (!querySnapshot.empty) {
        //We know there is one doc in the querySnapshot
        const queryDocumentSnapshot = querySnapshot.docs[0]; 
        //console.log(queryDocumentSnapshot.ref.id)

        let ref = db.collection("projects").doc(this.getProjectID()).collection('businessfoundationdetails').doc(queryDocumentSnapshot.ref.id)
          ref.get()
          .then(snapshot => {  //DocSnapshot
                if (snapshot.exists) {
                    this.businessfoundationdetails = snapshot.data()
                    //console.log(this.parallelSolutionConceptsToBeDisplayed.solutionname)
                } else {
                    // snapshot.data() will be undefined in this case
                    //console.log("No such document!");
                }  
          })


    } else {
        //console.log("No document corresponding to the query!");
        return null;
    }
});
// End of section  

// Getting the first aas offering from the list of such offerings  
 db.collection("projects").doc(this.getProjectID()).collection('aasofferings')
.limit(1)
.get()
.then(querySnapshot => {
    if (!querySnapshot.empty) {
        //We know there is one doc in the querySnapshot
        const queryDocumentSnapshot = querySnapshot.docs[0]; 
        //console.log(queryDocumentSnapshot.ref.id)

        let ref = db.collection("projects").doc(this.getProjectID()).collection('aasofferings').doc(queryDocumentSnapshot.ref.id)
          ref.get()
          .then(snapshot => {  //DocSnapshot
                if (snapshot.exists) {
                    this.aasofferings = snapshot.data()
                    //console.log(this.parallelSolutionConceptsToBeDisplayed.solutionname)
                } else {
                    // snapshot.data() will be undefined in this case
                    //console.log("No such document!");
                }  
          })


    } else {
        //console.log("No document corresponding to the query!");
        return null;
    }
});
// End of section 

// Getting the first ipproperty from the list of such properties  
 db.collection("projects").doc(this.getProjectID()).collection('ipproperties')
.limit(1)
.get()
.then(querySnapshot => {
    if (!querySnapshot.empty) {
        //We know there is one doc in the querySnapshot
        const queryDocumentSnapshot = querySnapshot.docs[0]; 
        //console.log(queryDocumentSnapshot.ref.id)

        let ref = db.collection("projects").doc(this.getProjectID()).collection('ipproperties').doc(queryDocumentSnapshot.ref.id)
          ref.get()
          .then(snapshot => {  //DocSnapshot
                if (snapshot.exists) {
                    this.ipproperties = snapshot.data()
                    //console.log(this.parallelSolutionConceptsToBeDisplayed.solutionname)
                } else {
                    // snapshot.data() will be undefined in this case
                    //console.log("No such document!");
                }  
          })


    } else {
        //console.log("No document corresponding to the query!");
        return null;
    }
});
// End of section 

// Getting the first synergy from the list of such synergies  
 db.collection("projects").doc(this.getProjectID()).collection('potentialsynergies')
.limit(1)
.get()
.then(querySnapshot => {
    if (!querySnapshot.empty) {
        //We know there is one doc in the querySnapshot
        const queryDocumentSnapshot = querySnapshot.docs[0]; 
        //console.log(queryDocumentSnapshot.ref.id)

        let ref = db.collection("projects").doc(this.getProjectID()).collection('potentialsynergies').doc(queryDocumentSnapshot.ref.id)
          ref.get()
          .then(snapshot => {  //DocSnapshot
                if (snapshot.exists) {
                    this.potentialsynergies = snapshot.data()
                    //console.log(this.parallelSolutionConceptsToBeDisplayed.solutionname)
                } else {
                    // snapshot.data() will be undefined in this case
                    //console.log("No such document!");
                }  
          })


    } else {
        //console.log("No document corresponding to the query!");
        return null;
    }
});
// End of section 

// Getting the first peoduct from the list of such competing products  
 db.collection("projects").doc(this.getProjectID()).collection('competingproducts')
.limit(1)
.get()
.then(querySnapshot => {
    if (!querySnapshot.empty) {
        //We know there is one doc in the querySnapshot
        const queryDocumentSnapshot = querySnapshot.docs[0]; 
        //console.log(queryDocumentSnapshot.ref.id)

        let ref = db.collection("projects").doc(this.getProjectID()).collection('competingproducts').doc(queryDocumentSnapshot.ref.id)
          ref.get()
          .then(snapshot => {  //DocSnapshot
                if (snapshot.exists) {
                    this.competingproducts = snapshot.data()
                    //console.log(this.parallelSolutionConceptsToBeDisplayed.solutionname)
                } else {
                    // snapshot.data() will be undefined in this case
                    //console.log("No such document!");
                }  
          })


    } else {
        //console.log("No document corresponding to the query!");
        return null;
    }
});
// End of section

//   const dbref = db.collection('projects').get().then(querySnapshot => { parallelsolutionconcepts
//   querySnapshot.forEach(documentSnapshot => {
//     console.log(`documentReference.id   = ${documentSnapshot.id}`);
//     console.log(`documentReference.path = ${documentSnapshot.ref.path}`);
//     // console.log(`documentReference.ref = ${JSON.stringify(documentSnapshot.ref)}`);
//   });
// });
    //console.log(this.solutionconcepts)

  }
};
</script>

<style>
.rounded-card{
  border-radius:20px;
}
</style>
